module.exports = __webpack_public_path__ + "img/imagem-planta-3d-palmeiras02.a1495b05.png";